const D1_CAUSE_CLASSES: ReadonlyArray<readonly [string, readonly string[]]> = [
  ['overloaded', ['overloaded', 'queued for too long', 'too many requests']],
  ['network-lost', ['network connection lost', 'connection lost']],
  ['timeout', ['storage operation exceeded timeout', 'exceeded timeout', 'storage caused']],
  ['reset', ['object reset', 'reset because']],
  ['internal', ['internal error']],
];

export function classifyD1Cause(text: string): string {
  const haystack = text.toLowerCase();
  const match = D1_CAUSE_CLASSES.find(([, needles]) =>
    needles.some((needle) => haystack.includes(needle)),
  );
  return match ? match[0] : 'other';
}
